import constants from '@core/utils/constants';
import { bus } from '@core/events/eventSystem';
import { serializer } from './serializer';
import { getStore } from '@core/store';

bus.on(constants.EVENTS.AFFILIATION.LIST_ALL.REFRESH, () => {
  const requestId = `listAllTransactions-${Date.now()}`;

  const userStore = getStore('user');
  let url = `${constants.ENDPOINTS.AFFILIATION.GET_LIST}`;
  url = url.replace('{userId}', userStore.state.current.id);

  bus.emit(EVENTS.AFFILIATION.LIST_ALL.REFRESHING);
  bus.emit(constants.EVENTS.NETWORK.REQUEST, {
    id: requestId,
    url,
    method: 'GET',
    data: {}
  });

  const handler = (res) => {
    if (res.id === requestId) {
      bus.off(constants.EVENTS.NETWORK.RESPONSE, handler);
      const parsed = serializer.deserialize(res);
      if (parsed.success) {
        bus.emit(EVENTS.AFFILIATION.LIST_ALL.REFRESHED, parsed.data);
      } else {
        bus.emit(EVENTS.AFFILIATION.LIST_ALL.REFRESH_ERROR, parsed);
      }
    }
  };
  bus.on(constants.EVENTS.NETWORK.RESPONSE, handler);
});
